import { Button, DialogContentText } from '@mui/material';
import { EnhancedDialog } from 'components/enhanced/dialog/EnhancedDialog';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PurchaseOrderPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  fulfillRequest: (sendEmail: boolean) => void;
  getOrderPreviewInnerContent: () => React.ReactNode;
  canSendEmail: boolean;
  sendEmailHint?: React.ReactNode;
}

const PurchaseOrderPreviewDialog: React.FC<PurchaseOrderPreviewDialogProps> = ({
  open,
  onClose,
  fulfillRequest,
  getOrderPreviewInnerContent,
  canSendEmail,
  sendEmailHint
}) => {
  const { t } = useTranslation(); // Assuming you're using react-i18next for translations

  return (
    <EnhancedDialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      title={'Anteprima ordine'}
      costumFooter={
        <div className="w-full flex justify-between">
          <Button onClick={onClose}>{t('actions.cancel')}</Button>
          <div className="flex items-center gap-3">
            {sendEmailHint ? <div className="text-xs text-gray-600">{sendEmailHint}</div> : null}
            <Button className="me-2" onClick={() => fulfillRequest(false)}>
              {t('actions.confirm')}
            </Button>
            <Button
              variant="contained"
              onClick={() => fulfillRequest(true)}
              autoFocus
              disabled={!canSendEmail}>
              {t('actions.confirm-send-email')}
            </Button>
          </div>
        </div>
      }>
      <DialogContentText id="alert-dialog-description">
        <p>{t('pages.purchase-requests.new.order-preview-description')}</p>
        {getOrderPreviewInnerContent()}
      </DialogContentText>
    </EnhancedDialog>
  );
};

export default PurchaseOrderPreviewDialog;
